import { render, staticRenderFns } from "./UserChangeAccountType.vue?vue&type=template&id=0a9a1ae2&"
import script from "./UserChangeAccountType.vue?vue&type=script&lang=js&"
export * from "./UserChangeAccountType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VResponsive})


/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a9a1ae2')) {
      api.createRecord('0a9a1ae2', component.options)
    } else {
      api.reload('0a9a1ae2', component.options)
    }
    module.hot.accept("./UserChangeAccountType.vue?vue&type=template&id=0a9a1ae2&", function () {
      api.rerender('0a9a1ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/UserChangeAccountType.vue"
export default component.exports